import clsx from "clsx";
import { Skeleton } from "@/components/ui/skeleton";
import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";
import { ButtonLayout } from "@/types/enums";

interface UnitItemLoadingProps {
    layout: "grid" | "row";
}
export const UnitItemLoading = ({ layout = "row" }: UnitItemLoadingProps) => {
    const { buttonLayout, disableRental, disableReservation } =
        useDisplayOptionContext();
    // No unit data here, so estimate the button count from config: combined
    // layout shows one Select button; separate layout shows up to two stacked
    // buttons (Rent + Reserve), minus any disabled action. Per-unit cases
    // (sold-out, reserve-only, etc.) are handled by the data-driven
    // SkeletonUnitItem, which renders the actual buttons.
    const actionButtonCount =
        buttonLayout === ButtonLayout.SEPARATE
            ? Math.max(1, (disableRental ? 0 : 1) + (disableReservation ? 0 : 1))
            : 1;
    return (
        <div
            className={clsx(
                "unit-item",
                "unit-item--loading",
                `unit-item--${layout}`,
            )}
        >
            <div className="unit-item__image">
                <Skeleton className="tw:h-[75px] tw:w-[75px]" />
            </div>
            <div className="unit-item__dimension">
                <Skeleton className="tw:h-4 tw:w-[100px]" />
            </div>
            <div className="unit-item__category">
                <Skeleton className="tw:h-4 tw:w-[100px]" />
            </div>
            <div className="unit-item__features">
                <ul className="unit-item-features">
                    <li className="unit-item-features__item">
                        <Skeleton className="tw:h-4 tw:mb-2 tw:w-[120px]" />
                    </li>
                    <li className="unit-item-features__item">
                        <Skeleton className="tw:h-4 tw:mb-2 tw:w-[120px]" />
                    </li>
                    <li className="unit-item-features__item">
                        <Skeleton className="tw:h-4 tw:mb-2 tw:w-[120px]" />
                    </li>
                </ul>
            </div>
            <div className="unit-item__promotions">
                <Skeleton className="tw:h-4 tw:w-[200px]" />
            </div>
            <div className="unit-item__urgency"></div>
            <div className="unit-item__price">
                <Skeleton className="tw:h-4 tw:mb-2 tw:w-[100px]" />
                <Skeleton className="tw:h-4 tw:w-[100px]" />
            </div>
            <div className="unit-item__action">
                {Array.from({ length: actionButtonCount }, (_, i) => (
                    <Skeleton
                        key={i}
                        className={clsx(
                            "tw:h-9 tw:w-full tw:rounded-full",
                            i > 0 && "tw:mt-1.5",
                        )}
                    />
                ))}
            </div>
        </div>
    );
};
